import { render, staticRenderFns } from "./QuotesFooter.vue?vue&type=template&id=46a5bc1e&scoped=true&"
import script from "./QuotesFooter.vue?vue&type=script&lang=js&"
export * from "./QuotesFooter.vue?vue&type=script&lang=js&"
import style0 from "./QuotesFooter.vue?vue&type=style&index=0&id=46a5bc1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5bc1e",
  null
  
)

export default component.exports